import type { Group as GroupType } from 'containers/Participants/Redux/Reducer/InitialStateType'

export const hasCustomGroup = (groups: GroupType[]) => {
  const customFilters = groups.filter(
    (group: GroupType) => !group.defaultSegment,
  )

  return customFilters.length > 0
}
